module.exports = __webpack_public_path__ + "img/midiadoor.fe693ccf.png";